import { render, staticRenderFns } from "./TaskComments.vue?vue&type=template&id=1aab5c2c&scoped=true"
import script from "./TaskComments.vue?vue&type=script&lang=js"
export * from "./TaskComments.vue?vue&type=script&lang=js"
import style0 from "./TaskComments.vue?vue&type=style&index=0&id=1aab5c2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aab5c2c",
  null
  
)

export default component.exports